import { useCurrentFrame, interpolate } from 'remotion';
import IdeShell from '../components/ide-shell';
import CodeEditorVideo from '../components/code-editor-video';
import OutputPanel from '../components/output-panel';

export default function HighlightScene({
  code = '',
  lineRange = [],
  narration,
  filename = 'Program.cs',
  projectName = 'HelloWorld',
  breakpoints,
  debugLine,
  step = 2,
}) {
  const frame = useCurrentFrame();
  const lineCount = code ? code.split('\n').length : 1;

  // Pulse highlight opacity
  const highlightOpacity = interpolate(
    frame % 120, [0, 60, 120], [0.15, 0.3, 0.15]
  );

  // Generate array of line numbers from range [start, end]
  const highlightLines = lineRange.length === 2
    ? Array.from({ length: lineRange[1] - lineRange[0] + 1 }, (_, i) => lineRange[0] + i)
    : lineRange;

  return (
    <IdeShell projectName={projectName} filename={filename} step={step} lineCount={lineCount}>
      <CodeEditorVideo
        typedCode={code}
        step={step}
        lineCount={lineCount}
        projectName={projectName}
        filename={filename}
        highlightLines={highlightLines}
        highlightOpacity={highlightOpacity}
        breakpoints={breakpoints}
        debugLine={debugLine}
      />
      <OutputPanel buildLogs={[]} />
      {/* Narration handled by OverlayLayer — no duplicate subtitle here */}
    </IdeShell>
  );
}
